import React from 'react';
import { fetchWithAuth } from '../api';
import Layout from '../components/ui/Layout';
import { getCurrentUser, removeToken } from '../auth';
import { useNavigate, Link } from 'react-router-dom';
import Button from '../components/ui/Button';

interface DisputesPageProps {
  isClient?: boolean;
}

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const DisputesPage: React.FC<DisputesPageProps> = ({ isClient = false }) => {
  const [tab, setTab] = React.useState<'active' | 'done'>('active');
  const [items, setItems] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);
  const navigate = useNavigate();

  const statusFilter = tab === 'active' ? 'На проверке' : undefined; // done -> both approved + rejected

  const load = React.useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      if (isClient) {
        const url = `${API_URL}/disputs/leads/my${statusFilter ? `?status=${encodeURIComponent(statusFilter)}` : ''}`;
        const res = await fetchWithAuth(url);
        const data = await res.json();
        const rawItems = data.data || data || [];
        const filtered = tab === 'active'
          ? rawItems.filter((it: any) => it.disput_status === 'На проверке')
          : rawItems.filter((it: any) => it.disput_status && it.disput_status !== 'На проверке');
        setItems(filtered);
      } else {
        const url = `${API_URL}/disputs/leads${statusFilter ? `?status=${encodeURIComponent(statusFilter)}` : ''}`;
        const res = await fetchWithAuth(url);
        const data = await res.json();
        const rawItems = data.data || data || [];
        const filtered = tab === 'active'
          ? rawItems.filter((it: any) => it.disput_status === 'На проверке')
          : rawItems.filter((it: any) => it.disput_status && it.disput_status !== 'На проверке');
        setItems(filtered);
      }
    } catch (e: any) {
      setError(e.message || 'Ошибка загрузки');
    } finally {
      setLoading(false);
    }
  }, [isClient, statusFilter, tab]);

  React.useEffect(() => {
    load();
  }, [load]);

  const handleLogout = () => {
    removeToken();
    navigate('/login');
  };

  const content = (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <Button
          variant={tab === 'active' ? 'primary' : 'ghost'}
          onClick={() => setTab('active')}
        >
          Активные
        </Button>
        <Button
          variant={tab === 'done' ? 'primary' : 'ghost'}
          onClick={() => setTab('done')}
        >
          Завершенные
        </Button>
      </div>

      {loading ? (
        <div>Загрузка...</div>
      ) : error ? (
        <div style={{ color: 'red' }}>{error}</div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '600px' }}>
            <thead>
              <tr style={{ backgroundColor: '#f5f5f5' }}>
                <th style={{ padding: 8, border: '1px solid #ddd' }}>ID</th>
                <th style={{ padding: 8, border: '1px solid #ddd' }}>Телефон</th>
                <th style={{ padding: 8, border: '1px solid #ddd' }}>Клиент</th>
                <th style={{ padding: 8, border: '1px solid #ddd' }}>Статус спора</th>
                <th style={{ padding: 8, border: '1px solid #ddd' }}>Создан</th>
                <th style={{ padding: 8, border: '1px solid #ddd' }}></th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 ? (
                <tr><td colSpan={6} style={{ padding: 16, textAlign: 'center' }}>Нет записей</td></tr>
              ) : (
                items.map((it: any) => (
                  <tr key={it.id}>
                    <td style={{ padding: 8, border: '1px solid #ddd' }}>{it.id}</td>
                    <td style={{ padding: 8, border: '1px solid #ddd' }}>{it.phone || '-'}</td>
                    <td style={{ padding: 8, border: '1px solid #ddd' }}>{it.customer_name || '-'}</td>
                    <td style={{ padding: 8, border: '1px solid #ddd' }}>{it.disput_status || '-'}</td>
                    <td style={{ padding: 8, border: '1px solid #ddd' }}>{it.created_at ? new Date(it.created_at).toLocaleString('ru-RU') : '-'}</td>
                    <td style={{ padding: 8, border: '1px solid #ddd' }}>
                      <Link to={isClient ? `/client/disputs/${it.id}` : `/disputs/${it.id}`}>
                        <Button variant="primary">Открыть</Button>
                      </Link>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );

  if (isClient) {
    const user = getCurrentUser();
    return (
      <Layout user={user} onLogout={handleLogout}>
        {content}
      </Layout>
    );
  }

  return content;
};

export default DisputesPage; 